import React, { forwardRef, useEffect, useState } from 'react';
import styles from './OrganisationYINC.module.scss';
import { Notification, FormInput } from '@snsw/react-component-library';
import { validate, isCompleted } from '../Utils/Validation';

const OrganisationYINC = (props, ref) => {
  if (ref) {
    ref.current = {
      validate: () => {
        const isValid = validate(validators, setErrors);
        setShowErrors(!isValid);
        return isValid;
      }
    };
  }

  const [showErrors, setShowErrors] = useState(false);
  const [errors, setErrors] = useState({});
  const validators = [
    {
      fieldName: 'YINCDetails',
      fieldValue: props.YINCDetails,
      isValid: isCompleted
    },
    {
      fieldName: 'YINCName',
      fieldValue: props.YINCName,
      isValid: isCompleted
    }
  ];

  if (props.YINCTradingName) {
    validators.push({
      fieldName: 'YINCTradingName',
      fieldValue: props.YINCTradingName,
      isValid: props.YINCTradingName
    });
  }

  useEffect(() => {
    if (showErrors) {
      const isValid = validate(validators, setErrors);
      setShowErrors(!isValid);
    }
  }, [props.YINCDetails, props.YINCName, props.YINCTradingName]);

  return (
    <>
      <div className={'row'}>
        <div className={`col-12 ${styles.note}`}>
          <span>
            Assoc. Incorporated Number issued within NSW are either 'Y plus 7 digits e.g. Y1234567' or 'INC plus 7
            digits e.g. INC1234567'. The format may vary for other states.
          </span>
        </div>
      </div>
      <div className={'row'}>
        <div className={`col-12`}>
          <FormInput
            label={'Please provide your Assoc. Incorporated Organisation Details'}
            errorMessage={'Assoc. Incorporated Number is required.'}
            hasError={showErrors && errors.YINCDetails}
            placeholder={'Assoc. Incorporated Number'}
            value={props.YINCDetails}
            onChange={(evt) => {
              props.setYINCDetails(evt.target.value);
            }}
          />
        </div>
      </div>

      <div className={'row'}>
        <div className={`col-12`}>
          <FormInput
            label={'Organisation Name'}
            errorMessage={'Organisation Name is required.'}
            hasError={showErrors && errors.YINCName}
            value={props.YINCName}
            onChange={(evt) => {
              props.setYINCName(evt.target.value);
            }}
          />
        </div>
      </div>
      {props.YINCTradingName ? (
        <>
          <div className={'row'}>
            <div className={`col-12 ${styles.section}`}>
              <FormInput
                label={'Registered Trading Name'}
                errorMessage={`Registered Trading Name is required.`}
                hasError={showErrors && errors.YINCTradingName}
                value={props.YINCTradingName}
                onChange={(evt) => {
                  props.setYINCTradingName(evt.target.value);
                }}
              />
            </div>
          </div>
        </>
      ) : null}
    </>
  );
};
export default forwardRef(OrganisationYINC);
